import classNames from 'classnames';
import React, { PropsWithChildren } from 'react';
import { useWorklistTheme } from '../../hooks/useWorklistTheme';

/**
 * The light (or dark) page the worklist is drawn on, in the theme the user picked: it sets the `dl-*`
 * colours (gleamer-overrides.css) for everything inside it.
 *
 * OHIF's ui-next stylesheet forces `body { !bg-black }` for the viewer, so the surface paints its own
 * background over it; `gleamer-worklist-surface` also makes it as wide as the content, so scrolling right on
 * a narrow screen does not run past it onto that black body.
 */
export function WorklistSurface({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) {
  const [theme] = useWorklistTheme();
  return (
    <div
      data-theme={theme}
      className={classNames(
        'gleamer-worklist-surface min-h-screen bg-dl-bg font-sans text-dl-text antialiased',
        className
      )}
    >
      {children}
    </div>
  );
}
